export const formatDkIban = (input: string): string => {
  const slicedPart = input.slice(4)
  const prefix = slicedPart.slice(0, 4)
  const suffix = slicedPart.slice(4)
  return `${prefix}-${suffix}`
}

export const formatIban = (input?: string, currencyCode?: string): string => {
  if (!input) {
    return ''
  }

  if (!currencyCode || currencyCode === 'DKK') {
    return formatDkIban(input)
  }

  return input
}
